import React, { useEffect, useState } from 'react';
import Modal from 'components/Tvendo/Common/ModalBase';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import { wsGetAll } from 'services/WService';

function RouteInfoModal(props) {
  const { model, setOpen, showNotify } = props;
  const [data, setData] = useState([]);
  const [sellers, setSellers] = useState([]);

  async function getData() {
    let res = await wsGetAll(
      `quota/provider/${model.routeQuota.quota_provider_id}/route/${model.routeQuota.id}`,
    );
    if (res.success) {
      setData(res.data.report);
      setSellers(res.data.carteraMesa);
    }
  }

  useEffect(() => {
    if (model.routeQuota === undefined) return;
    getData();
  }, [model.routeQuota]);

  return (
    <Modal
      title="Información"
      model={model}
      setOpen={() => {
        setData([]);
        setSellers([]);
        setOpen({ open: false });
      }}
      disabledSave
      entity=""
    >
      <TableContainer>
        <Typography>Vendedores activos</Typography>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Vendedor</TableCell>
              <TableCell>Mesa</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sellers.map((seller, index) => {
              return (
                <TableRow key={`${seller.seller.id}-${seller.bureau.id}`}>
                  <TableCell>
                    ({seller.seller.SlpCode}) {seller.seller.SlpName}
                  </TableCell>
                  <TableCell>
                    ({seller.bureau.code}) {seller.bureau.description}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <br />
      <TableContainer>
        <Typography>Información de vendedores por periodo</Typography>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Periodo</TableCell>
              <TableCell>Vendedor</TableCell>
              <TableCell>Documentos</TableCell>
              <TableCell>Total</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, index) => {
              return (
                <TableRow key={index}>
                  <TableCell>{row.periodo}</TableCell>
                  <TableCell>{row.SlpName}</TableCell>
                  <TableCell>{row.Documentos}</TableCell>
                  <TableCell>S/ {row.GTotal}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Modal>
  );
}

export default RouteInfoModal;
